<template>
    <div class="d-flex gap-2 mt-2 flex-wrap">
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-inscrits">{{ parcours.statistique.inscrits }}</div>
            <div class="box-stats-title">Inscrits</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-partis">{{ parcours.statistique.pris_depart }}</div>
            <div class="box-stats-title">Partants</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-en_course">{{ parcours.statistique.en_course }}</div>
            <div class="box-stats-title">En course</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-arrives">{{ parcours.statistique.arrives }}</div>
            <div class="box-stats-title">Arrivés</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-abandons">{{ parcours.statistique.abandons }}</div>
            <div class="box-stats-title">Abandons</div>
        </div>
        <div class="box-stats">
            <div class="box-stats-value box-stats-value-disqualifies">{{ parcours.statistique.disqualifie }}</div>
            <div class="box-stats-title">Disqualifiés</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['parcours'],

}
</script>

<style lang="scss" scoped>
.box-stats {
    background-color: white;
    font-weight: bold;
    padding: 10px;
    border-radius: 5px;
    min-width: 100px;
    border: 1px solid #dbe0e6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.box-stats-value {
    font-size: 1.2rem;
}

.box-stats-value-inscrits {
    color: #bd7101;
}

.box-stats-value-partis {
    color: #0143bd;
}

.box-stats-value-en_course {
    color: #babd01;
}

.box-stats-value-arrives {
    color: #037403;
}

.box-stats-value-abandons {
    color: #790101;
}

.box-stats-value-disqualifies {
    color: #790101;
}
</style>